import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { paths } from "config/paths";
import dayjs from "dayjs";
import Link from "next/link";
import { FC } from "react";
import { Account } from "~ui-components/types/__generated/gql/graphql";
import { useWebRouter } from "~utils/next-router/use-web-router";

interface TrialRemainingCardProps {
	account: Account;
}

export const TrialRemainingCard: FC<TrialRemainingCardProps> = ({
	account,
}) => {
	const router = useWebRouter();

	const remainingDays = Math.max(
		dayjs(account.subscription.trialExpiresAt).diff(dayjs(), "day"),
		0,
	);

	return (
		<Card>
			<CardContent>
				<Stack
					spacing={3}
					gap={10}
					justifyContent={"space-between"}
					sx={{ paddingY: 2 }}>
					<Stack
						direction={{ xs: "column", md: "row" }}
						spacing={3}
						justifyContent={"space-between"}
						alignItems={"center"}>
						<Typography variant="h6">Welcome to your trial</Typography>
						<Button
							LinkComponent={Link}
							variant="contained"
							href={paths.accountName.settings.editSubscription(
								router._query.accountName,
							)}>
							Upgrade to paid
						</Button>
					</Stack>
					<Stack spacing={2}>
						<Typography variant="subtitle2">
							Try any feature and any plan free for 30 days, no obligation. If
							you have any questions or specific procurement need, please
							don&apos;t hesitate to contact our responsive support team.
						</Typography>
						<Stack
							spacing={2}
							direction={"row"}
							alignItems={"center"}>
							<LinearProgress
								sx={{
									flex: "1 1 auto",
									height: "6px",
									transform: "scaleX(-1)",
								}}
								value={(remainingDays / 30) * 100}
								variant="determinate"
							/>
							<Typography variant="subtitle2">
								Expires{" "}
								{dayjs(account.subscription.trialExpiresAt).format(
									"MMM D, YYYY",
								)}
							</Typography>
						</Stack>
						<Typography variant="subtitle2">
							{remainingDays} days remaining
						</Typography>
					</Stack>
				</Stack>
			</CardContent>
		</Card>
	);
};
